import React, { useEffect, useState } from "react";
import logo from "./assets/saiVaniLogo.png";
import profileImageForSaivani from "./assets/profileImageForSaivani.png"
import "./App.css";
import Alert from './Alert'

import {
  AppBar,
  Toolbar,
  Avatar,
  Typography,
  Button,
  IconButton,
  CircularProgress,
  Popover,
  Snackbar
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import MenuIcon from "@material-ui/icons/Menu";

import { Route, withRouter } from "react-router-dom";
import BasicIntraday from "./BasicIntraday.js";
import LongTerm from "./LongTerm";

import store, {
  screenWidthIsSmall,
  fetchSymbols,
  userLoginSwitch,
  switchDarkMode,
  handleLoading,
  pushDataToTabs,
  setCurrentExpiryMonth
} from "./store";
import { useSelector } from "react-redux";
import clsx from "clsx";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AdvancedIntraday from "./AdvancedIntraday";
import SwingMaster from "./SwingMaster";
import Login from "./Login";

import firebase from "firebase/app";
import "firebase/firestore";
import AddNewSymbol from "./AddNewSymbol";

import FingerprintJS from '@fingerprintjs/fingerprintjs'

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load({
  monitoring: false
})

const useStyles = makeStyles({
  list: {
    width: 250
  },
  fullList: {
    width: "auto"
  }
});

const planDetails = {
  1: { name: "1 Week", days: 7 },
  2: { name: "1 Month", days: 30 },
  3: { name: "3 Months", days: 90 },
  4: { name: "6 Months", days: 180 },
  5: { name: "1 Year", days: 365 }
};

const vertical = 'top'
const horizontal = 'right'

const App = (props) => {
  const classes = useStyles();
  const path = props.history.location.pathname;
  const isUserLogin = useSelector((state) => state.initFunction.isUserLogin);
  const darkMode = useSelector((state) => state.initFunction.darkMode);
  const loading = useSelector((state) => state.initFunction.loading);
  const name = useSelector((state) => state.initFunction.name);
  const startDate = useSelector((state) => state.initFunction.startDate);
  const plan = useSelector((state) => state.initFunction.plan);
  const planExpiryDate = useSelector((state) => state.initFunction.planExpiryDate);
  const [categories, setCategories] = React.useState("");

  const [ openSnackBar, setSnackBar ] = useState(false)
  const [ snackMessage, setSnackMessage ] = useState('Symbol not exist')
  const [ snackStatus, setSnackStatus ] = useState('')

  const [ planExpiresSoon, setPlanExpiresSoon ] = useState(false)

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [state, setState] = React.useState({
    left: false,
  });

  const [localDummyState, setLocalDummyState] = React.useState(false)

  const isSmallScreen = useSelector(
    (state) => state.initFunction.isSmallScreen
  )

  useEffect(() => {
    store.dispatch(screenWidthIsSmall)
    checkUserlogIn()
    store.dispatch(fetchSymbols)
    store.dispatch(setCurrentExpiryMonth)
  }, [])

  function loadTabsData(arrayName, data, db) {

    if (data.length === 0) {
      return;
    }

    data.map((item) => {
      let docRef = db.collection(arrayName).doc(item);

      docRef
        .get()
        .then(function (doc) {
          let tabData = {
            ...doc.data(),
            ...{
              docId: item
            },
          };

          store.dispatch(pushDataToTabs({ payload: tabData, arrayName }));
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  const checkUserlogIn = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        let deviceFingerPrint;
        fpPromise
          .then(fp => fp.get())
          .then(result =>
            deviceFingerPrint = result.visitorId
          )
        const db = firebase.firestore();
        let docRef = db.collection("userData").doc(user.uid);

        docRef
          .get()
          .then((doc) => {
            if (doc.data()['deviceId'] === "") {
              docRef.update({
                deviceId: deviceFingerPrint
              })
              .then((_)=> {
                store.dispatch(handleLoading({ data: true }));
                setLocalDummyState(!localDummyState)
              })
              .catch((err) => {
                console.error(err);
                return;
              })
            } else if(doc.data()['deviceId'] !== deviceFingerPrint) {
              alert("Your account has been signed in other device. Please do sign out from that device else reach admin.")

              firebase
                .auth()
                .signOut()
                .then(_ => {
                  window.location.reload()
                })
                .catch(err => console.error(err));
              return;
            } 

            let categoriesCopy = doc.data()["category"].split(".");
            setCategories(categoriesCopy);

            if (doc.data()["isUserDisabled"]) {
              firebase
                .auth()
                .signOut()
                .then(() => {
                  alert("Your account has been disabled! Please contact the admin.");
                  props.history.push('/')
                  window.location.reload()
                });
              return;
            }

            let expiryDate = new Date(doc.data()["expiryDate"])
            if(new Date(doc.data()["expiryDate"]).toString() === 'Invalid Date') {
              expiryDate = new Date(doc.data()["expiryDate"].toDate())
            }

            let startDate = new Date(doc.data()["startDate"])
            if(new Date(doc.data()["startDate"]).toString() === 'Invalid Date') {
              startDate = new Date(doc.data()["startDate"].toDate())
            }

            if (startDate > new Date()) {
              firebase
                .auth()
                .signOut()
                .then(() => {
                  setSnackMessage("Your subscription plan not started yet.");
                  setSnackStatus("info");
                  setSnackBar(true);

                  props.history.push('/')
                  window.location.reload()
                });
              return;
            }

            if (expiryDate < new Date()) {
              firebase
                .auth()
                .signOut()
                .then(() => {
                  setSnackMessage("Your subscription plan has been expired. Please contact admin.");
                  setSnackStatus("error");
                  setSnackBar(true);
                  props.history.push('/')
                  window.location.reload()
                })
              return;
            }

            let date1;

            if(new Date(doc.data()["expiryDate"]).toString() === 'Invalid Date') {
              date1 = new Date(doc.data()["expiryDate"].toDate())
            } else {
              date1 = new Date(doc.data()["expiryDate"])
            }
            const date2 = new Date()
            const diffTime = Math.abs(date2 - date1);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if(diffDays < 5) {
              setPlanExpiresSoon(true)
              setSnackMessage("Your subscription plan will expire in "+ diffDays +" days");
              setSnackStatus("error");
              setSnackBar(true);
            }

            store.dispatch(
              switchDarkMode({ value: doc.data()["darkMode"], name: doc.data()["name"], date: doc.data()["expiryDate"], startDate: doc.data()["startDate"], plan: doc.data()["plan"] })
            );

            if (doc.data()["darkMode"]) {
              document.body.style.backgroundColor = "#000000de";
            }

            categoriesCopy[0] == "1" && loadTabsData("intraDayTabs", doc.data()["intraDayTabs"], db);
            
            categoriesCopy[1] == "1" && loadTabsData("positionalTabs", doc.data()["positionalTabs"], db);
            
            categoriesCopy[3] == "1" && loadTabsData("advancedPositionalTabs", doc.data()["advancedPositionalTabs"], db);
            
            categoriesCopy[2] == "1" && loadTabsData("advancedIntradayTabs", doc.data()["advancedIntradayTabs"], db);
          })
          .then((_) => {
            setTimeout(() => {
              store.dispatch(userLoginSwitch({ data: true }));
              store.dispatch(handleLoading({ data: false }));
            }, 500);
          })
          .catch((err) => {
            firebase.auth().signOut()
              .then(() => {
                props.history.push("/");
                window.onbeforeunload = null
              });
            console.log(err);
          });
      } else {
        store.dispatch(handleLoading({ data: false }));
      }
    });
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }

    setSnackBar(false);
}

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === "top" || anchor === "bottom",
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {[
          { label: "Basic Intraday", route: "/" },
          { label: "Long term", route: "/LongTerm" },
          { label: "Advanced Intraday", route: "/AdvancedIntraday" },
          { label: "Swing master", route: "/SwingMaster" },
        ].map((text, index) => (
          <ListItem
            button
            key={text.label}
            onClick={() => props.history.push(text.route)}
          >
            <ListItemText primary={text.label} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem>
          <Typography align="left" style={{ fontSize: 18, fontWeight: 'bold' }} noWrap>
            Profile
          </Typography>
        </ListItem>

        <ListItem style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} >
          <Typography noWrap align="left">
            Name
          </Typography>
          <Typography noWrap style={{ fontWeight: 'bold' }}>
            {name}
          </Typography>
        </ListItem>

        <ListItem style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} >
          <Typography noWrap align="left" >
            Subscription period
          </Typography>
          <Typography noWrap style={{ fontWeight: 'bold' }}>
            {planDetails[plan].name}
          </Typography>
        </ListItem>

        <ListItem style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} >
          <Typography noWrap align="left" >
            Start date
          </Typography>
          <Typography noWrap style={{ fontWeight: 'bold' }}>
            {
              new Date(startDate).toString() === 'Invalid Date' ? 
                new Date(startDate.toDate()).toDateString() : 
                new Date(startDate).toDateString()
            }
          </Typography>
        </ListItem>

        <ListItem style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }} >
          <Typography noWrap align="left" >
            Expiry date
          </Typography>
          <Typography noWrap style={{ fontWeight: 'bold', color: planExpiresSoon && "red" }}>
            {
              new Date(planExpiryDate).toString() === 'Invalid Date' ? 
                new Date(planExpiryDate.toDate()).toDateString() : 
                new Date(planExpiryDate).toDateString()
            }
          </Typography>
        </ListItem>

        <ListItem style={{ display: "flex", flexDirection: "column", flex: 1 }} >
          <Button
            onClick={() => handleDarkmode(!darkMode)}
            variant="outlined"
            style={{ marginBottom: 15, padding: 5, width: "100%" }}
            color={darkMode ? "primary" : "" }
          >
            {darkMode ? "Switch to light theme" : "Switch to dark theme"}
          </Button>
        </ListItem>

        <ListItem style={{ display: "flex", flexDirection: "column", flex: 1 }} >
          <Button
            style={{ padding: 5, width: "100%" }}
            onClick={handleSignOut}
            variant="outlined"
            color="secondary"
          >
            Sign out
          </Button>
        </ListItem>
        <ListItem style={{ display: "flex", flexDirection: "column", flex: 1 }} >
          <Typography
            align="center"
            variant="caption"
            style={{ marginTop: 10 }}
            noWrap
          >
            Version 1.0.0
          </Typography>
        </ListItem>
      </List>
    </div>
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleSignOut = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const db = firebase.firestore();
        let docRef = db.collection("userData").doc(user.uid)
        docRef
          .update({
            deviceId: ""
          })
          .then((_) => {
            firebase
              .auth()
              .signOut()
              .then(() => {
                props.history.push("/");
                window.onbeforeunload = null
                window.location.reload();
              });
          });
      }
    });
  };

  const handleDarkmode = (key) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const db = firebase.firestore();
        let docRef = db.collection("userData").doc(user.uid);
        docRef
          .update({
            darkMode: !darkMode,
          })
          .then((_) => {
            window.location.reload()
          });
      }
    });
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
        width: "100%",
        color: darkMode ? "white" : "black",
      }}
    >
      <CircularProgress />
    </div>
  ) : isUserLogin ? (
    <div
      style={{
        width: "100%",
        backgroundColor: darkMode ? "" : "white",
        color: darkMode ? "white" : "black",
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
        open={openSnackBar}
        onClose={handleSnackBarClose}
        autoHideDuration={2000}
        message={snackMessage}
      >
        <Alert onClose={handleSnackBarClose} severity={snackStatus}>
          {snackMessage}
        </Alert>
      </Snackbar>
      {isSmallScreen ? (
        <div style={{ display: "flex", marginTop: 10 }}>
          <React.Fragment key={"left"}>
            <IconButton onClick={toggleDrawer("left", true)} style={{}}>
              <MenuIcon style={{ color: darkMode ? "white" : "black" }} />
            </IconButton>

            <SwipeableDrawer
              anchor={"left"}
              open={state["left"]}
              onClose={toggleDrawer("left", false)}
              onOpen={toggleDrawer("left", true)}
            >
              {list("left")}
            </SwipeableDrawer>
          </React.Fragment>

          <img src={logo} style={{ marginLeft: 0 }} alt="logo" />
          {/* <div style={{ display: 'flex', alignContent: 'center' }} >
            <h3>
              Inovier consultants
            </h3>
          </div>           */}
        </div>
      ) : (
        <AppBar
          position="static"
          color="transparent"
          style={{ boxShadow: "0px 0px" }}
        >
          <Toolbar>
            <img
              src={logo}
              style={{ marginTop: 7, marginBottom: 7 }}
              alt="logo"
            />
            {/* <h3
              style={{ marginTop: 7, marginBottom: 7 }}
            >
              Inovier consultants
            </h3> */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginLeft: 50,
                width: "70%",
              }}
            >
              {categories[0] == "1" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 10,
                    color: path === "/" ? !darkMode ? "black" : "#ffffff" : "grey",
                    cursor: "pointer",
                  }}
                  onClick={() => props.history.push("/")}
                >
                  
                  <Typography variant="title" style={{ marginLeft: 0,fontSize: 18, fontWeight: 'bold' }}>
                    {" "}
                    Basic Intraday{" "}
                  </Typography>
                </div>
              )}

              {categories[1] == "1" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 10,
                    color: path === "/LongTerm" ? !darkMode ? "black" : "#ffffff" : "grey",
                    cursor: "pointer",
                  }}
                  onClick={() => props.history.push("/LongTerm")}
                >
                  
                  <Typography variant="title" style={{ marginLeft: 0,fontSize: 18, fontWeight: 'bold' }}>
                    {" "}
                    Long term{" "}
                  </Typography>
                </div>
              )}

              {categories[2] == "1" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 10,
                    color: path === "/AdvancedIntraday" ? !darkMode ? "black" : "#ffffff" : "grey",
                    cursor: "pointer"
                  }}
                  onClick={() => props.history.push("/AdvancedIntraday")}
                >
                  
                  <Typography variant="title" style={{ marginLeft: 0,fontSize: 18, fontWeight: 'bold' }}>
                    {" "}
                    Advanced Intraday{" "}
                  </Typography>
                </div>
              )}

              {categories[3] == "1" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 10,
                    color: path === "/SwingMaster" ? !darkMode ? "black" : "#ffffff" : "grey",
                    cursor: "pointer"
                  }}
                  onClick={() => props.history.push("/SwingMaster")}
                >
                  <Typography variant="title" style={{ marginLeft: 0,fontSize: 18, fontWeight: 'bold' }}>
                    Swing master
                  </Typography>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: 10,
                  color: path === "/AddSymbolManualy" ? !darkMode ? "black" : "#ffffff" : "grey",
                  cursor: "pointer"
                }}
                onClick={() => props.history.push("/AddSymbolManualy")}
              >
                
                <Typography variant="title" style={{ marginLeft: 0,fontSize: 18, fontWeight: 'bold' }}>
                  Add symbol
                </Typography>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flex: 1,
                justifyContent: "flex-end",
                cursor: "pointer",
              }}
            >
              <Avatar
                alt="Remy Sharp"
                src={profileImageForSaivani}
                onClick={handleClick}
              />
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                style={{ padding: 15 }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <div
                  style={{
                    padding: 10,
                    width: 250,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    align="left"
                    style={{ padding: 5, paddingBottom: 2, fontSize: 18, fontWeight: 'bold' }}
                    noWrap
                  >
                    Profile
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, marginTop: 2, padding: 5 }}>
                    <Typography noWrap align="left">
                      Name
                    </Typography>
                    <Typography noWrap style={{ fontWeight: 'bold' }}>
                      {name}
                    </Typography>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, marginTop: 2, padding: 5 }}>
                    <Typography noWrap align="left" >
                      Subscription period
                    </Typography>
                    <Typography noWrap style={{ fontWeight: 'bold' }}>
                      {planDetails[plan].name}
                    </Typography>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, marginTop: 2, padding: 5 }}>
                    <Typography noWrap align="left" >
                      Start date
                    </Typography>
                    <Typography noWrap style={{ fontWeight: 'bold' }}>
                      {
                        new Date(startDate).toString() === 'Invalid Date' ? 
                          new Date(startDate.toDate()).toDateString() : 
                          new Date(startDate).toDateString()
                      }
                    </Typography>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5, marginTop: 2, padding: 5 }}>
                    <Typography noWrap align="left" >
                      Expiry date
                    </Typography>
                    <Typography noWrap style={{ fontWeight: 'bold', color: planExpiresSoon && "red" }}>
                      {
                        new Date(planExpiryDate).toString() === 'Invalid Date' ? 
                          new Date(planExpiryDate.toDate()).toDateString() : 
                          new Date(planExpiryDate).toDateString()
                      }
                    </Typography>
                  </div>

                  <Button
                    onClick={() => handleDarkmode(!darkMode)}
                    variant="outlined"
                    style={{ marginBottom: 15, marginTop: 20, padding: 5 }}
                    color={darkMode ? "primary" : "" }
                  >
                    {darkMode ? "Switch to light theme" : "Switch to dark theme"}
                  </Button>
                  <Button
                    style={{ padding: 5 }}
                    onClick={handleSignOut}
                    variant="outlined"
                    color="secondary"
                  >
                    Sign out
                  </Button>
                  <Typography
                    align="center"
                    variant="caption"
                    style={{ marginTop: 10 }}
                    noWrap
                  >
                    Version 1.0.0
                  </Typography>
                </div>
              </Popover>
            </div>
          </Toolbar>
        </AppBar>
      )}

      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        {categories[0] == "1" && <Route path="/" exact component={BasicIntraday} />}
        {categories[1] == "1" && (
          <Route path="/LongTerm" exact component={LongTerm} />
        )}
        {categories[2] == "1" && (
          <Route path="/AdvancedIntraday" exact component={AdvancedIntraday} />
        )}
        
        {categories[3] == "1" && (
          <Route
            path="/SwingMaster"
            exact
            component={SwingMaster}
          />
        )}

        <Route path="/AddSymbolManualy" exact component={AddNewSymbol} />
      </div>
    </div>
  ) : (
    <div
      style={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Route path="/" exact component={Login} />
    </div>
  );
};

export default withRouter(App);
